import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import favicon64 from '../images/favico64.png'
import favicon32 from '../images/favico32.png'
import favicon16 from '../images/favico16.png'

function SEO({ description, lang, meta, keywords, title }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaDescription =
          description || data.site.siteMetadata.description
        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            link={[
              {
                rel: 'icon',
                type: 'image/png',
                sizes: '16x16',
                href: `${favicon16}`,
              },
              {
                rel: 'icon',
                type: 'image/png',
                sizes: '32x32',
                href: `${favicon32}`,
              },
              { rel: 'shortcut icon', type: 'image/png', href: `${favicon64}` },
            ]}
            title={title}
            titleTemplate={`%s | ${data.site.siteMetadata.title}`}
            meta={[
              {
                name: `description`,
                content:
                  'MS-MEBLE Małyjurek to wyjątkowa firma, która projektuje kuchnie według indywidualnych projektów. Pomożemy Państwu stworzyć kuchnie pełną dobrych smaków, optymalnie dopasowaną do Państwa potrzeb, wymagań i pomysłów… Tym co wyróżnia kuchnie MS-MEBLE jest przede wszystkim ich jakość i cena. Z racji tego, że do każdego wnętrza podchodzimy indywidualnie, koszt realizacji może zostać dopasowany do Państwa możliwości. Szeroka oferta komponentów z których powstaje finalny produkt jakim jest państwa kuchnia daje nam duże możliwości optymalnego zaaranżowania Państwa wnętrza.',
              },
              {
                property: `og:title`,
                content: title,
              },
              {
                property: `og:description`,
                content:
                  'MS-MEBLE Małyjurek to wyjątkowa firma, która projektuje kuchnie według indywidualnych projektów. Pomożemy Państwu stworzyć kuchnie pełną dobrych smaków, optymalnie dopasowaną do Państwa potrzeb, wymagań i pomysłów… Tym co wyróżnia kuchnie MS-MEBLE jest przede wszystkim ich jakość i cena. Z racji tego, że do każdego wnętrza podchodzimy indywidualnie, koszt realizacji może zostać dopasowany do Państwa możliwości. Szeroka oferta komponentów z których powstaje finalny produkt jakim jest państwa kuchnia daje nam duże możliwości optymalnego zaaranżowania Państwa wnętrza.',
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                name: `twitter:card`,
                content: `summary`,
              },
              {
                name: `twitter:creator`,
                content: data.site.siteMetadata.author,
              },
              {
                name: `twitter:title`,
                content: title,
              },
              {
                name: `twitter:description`,
                content: metaDescription,
              },
            ]
              .concat(
                keywords.length > 0
                  ? {
                      name: `keywords`,
                      content: keywords.join(`, `),
                    }
                  : []
              )
              .concat(meta)}
          />
        )
      }}
    />
  )
}

SEO.defaultProps = {
  lang: `pl`,
  meta: [],
  keywords: [],
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
}

export default SEO

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`
